module.exports = __webpack_public_path__ + "img/homeBackground.bbbe9c92.png";